const I18nKeys = {
    "missing.name": "O campo \"Nome\" é obrigatório.",
    "missing.value": "O campo \":type\" é obrigatório.",
    "name.already.registered": "Este \"Nome da rede\" já está sendo utilizado.",
    "ACTIVE": "Ativa",
    "INVALID": "Inválida",
    "DUPLICATE": "Duplicada",
    "CONCLUDED": "Concluída",
    "REJECTED": "Rejeitada",
}

export default I18nKeys;